import NeighborhoodsGrid from './neighborhoods-grid';
export default NeighborhoodsGrid;